import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  OnboardingDetailSection,
  OnboardingSectionSavePayload,
  sectionHasMeaningfulContent,
} from '../onboarding-vessel-mapper.util';

@Component({
  selector: 'app-emission-detail',
  templateUrl: './emission-detail.component.html',
  styleUrls: ['./emission-detail.component.scss'],
})
export class EmissionDetailComponent {
  @Input() vesselName = '';
  @Input() loading = false;
  @Input() isDarkMode = false;
  @Input() embedded = false;
  @Input() savingSectionId: string | null = null;
  @Input() sections: OnboardingDetailSection[] = [];
  @Output() back = new EventEmitter<void>();
  @Output() edit = new EventEmitter<void>();
  @Output() sectionSave = new EventEmitter<OnboardingSectionSavePayload>();

  expanded: Record<string, boolean> = {};

  get visibleSections(): OnboardingDetailSection[] {
    return (this.sections ?? []).filter(sectionHasMeaningfulContent);
  }

  toggleSection(id: string): void {
    this.expanded[id] = !this.expanded[id];
  }

  isExpanded(id: string): boolean {
    return this.expanded[id] !== false;
  }

  onSectionSave(payload: OnboardingSectionSavePayload): void {
    this.sectionSave.emit(payload);
  }

  trackSection(_index: number, section: OnboardingDetailSection): string {
    return section.id;
  }
}
